<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-row justify="center">
       
        <updateCard  
          v-for="(image, index) in images" :key="index"   
          :image="image"  
        >
        </updateCard>

        </v-row>
      </v-col>
    </v-row>
 </v-container>
</template>

<script>
  import updateCard  from "@/components/updateCard";
  import {mapActions } from "vuex";
export default {
  
  name: "Home",
  components: {
    updateCard
  },
  data() {
    return {
      images: [],
      items: []
    }
  }, 
  methods: {
    ...mapActions(['getAll']),
    find() {
      this.getAll().then(result =>{

        this.images =   result.data;

      }) 
    }
  }, 
  computed: {
    src: function() {
        if(process.env.NODE_ENV === 'production') {
            return "/api/images/image?filename="
        } else {
            return "http://localhost:5000/api/images/image?filename="
        }
    }
  },
  mounted() {
    this.find();
  }
}
</script>

<style>

</style>